import {
  SET_CULTURES,
  SET_CULTURES_SUCCESS,
  GET_GS_MODULE_ACTIVE,
  GET_GS_MODULE_ACTIVE_SUCCESS,
  SHOW_ENTITIES,
  SET_SHOW_ENTITIES,
} from "../types/actionTypes";

export const setCultures = () => ({
  type: SET_CULTURES,
});

export const setCulturesSuccess = (culture) => ({
  type: SET_CULTURES_SUCCESS,
  payload: culture,
});

export const getGsModuleActive = () => ({
  type: GET_GS_MODULE_ACTIVE,
});

export const getGsModuleActiveSuccess = ({ active }) => ({
  type: GET_GS_MODULE_ACTIVE_SUCCESS,
  payload: active,
});

export const showEntities = (payload) => ({
  type: SHOW_ENTITIES,
  payload,
});

export const setShowEntities = (payload) => ({
  type: SET_SHOW_ENTITIES,
  payload,
});
